// Identificador de la app en el RBAC del ERP (modules.app = 'WPBOT')
export const app = {
  Wpbot: "WPBOT"
} as const

export const baseURL = process.env.REACT_APP_MODULE_BASE_URL || ""

// Timezones comunes de Latinoamérica para la configuración del bot
export const LATAM_TIMEZONES = [
  "America/Bogota",
  "America/Lima",
  "America/Quito",
  "America/Panama",
  "America/Mexico_City",
  "America/Caracas",
  "America/Guatemala",
  "America/Costa_Rica",
  "America/La_Paz",
  "America/Santiago",
  "America/Buenos_Aires",
  "America/Montevideo",
  "America/Asuncion",
  "America/Sao_Paulo",
]

export const DEFAULT_TIMEZONE = "America/Bogota"
